var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('select',{attrs:{"multiple":_vm.multi}},_vm._l((_vm.options),function(option){return _c('option',{key:option},[_vm._v(" "+_vm._s(option)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }